// *** BUMP THIS VERSION ONLY WHEN UPDATING STARTER TEMPLATE ***
// BH Starter Template Version: 8.0.0

export const environment = {
  // Environment Name
  env: 'DEV',

  // Is Production Environment?
  production: false,

  // App Name/ID
  appName: 'MDONCALL',

  // App Description (full name)
  appDescription: 'MD OnCall',

  // App Version Number
  appVersion: '8.0.8',

  // App URL Scheme
  appUrlScheme: 'mdoncall:',

  // Web URL
  webUrl: 'https://dev.mdoncall.apps.baystatehealth.org',

  // App's REST Service API Root URL
  apiUrl: 'https://mobiledev.api.baystatehealth.org/mdoncall/api',

    // AWS Cognito API Root URL
    awsCognitoUrl: 'https://bh-dev-auth.auth.us-east-1.amazoncognito.com',

  // AWS Cognito Client ID for Auth (Needs client ID specific to app)
  awsCognitoClientId: '14kedbelcdiq45qbch2vuiurrt',

  // Using SSO Authentication
  ssoEnabled: true,

  // SSO callback base URL (must match Cognito app client Callback URL(s), e.g. https://dev.mdoncall.apps.baystatehealth.org/redirect)
  ssoCallbackUrl: 'https://dev.mdoncall.apps.baystatehealth.org',

  // App's Uploaded Files Root URL
  filesUrl: 'https://dev.ecalendar.apps.baystatehealth.org',

  // Verlocker API URL
  verlockerUrl: 'https://mobiledev.api.baystatehealth.org/verlocker',

  // BH AppStore Deep Link URL
  appstoreUrl: 'https://mobile.baystatehealth.org/ecalendar/',

  // Reset password link URL
  resetPwdUrl: 'https://aka.ms/sspr',

  // Change password security questions link URL
  changePwdQuestionsUrl: 'https://baystatehealth.service-now.com/b_sp?id=pwd_reset_enrollment',

  // Set theme preference: user, light, dark
  // 'user' option will allow user to select theme preference (recommended).
  // 'light' option locks app into light mode, and user cannot change it
  // 'dark' option locks app into dark mode, and user cannot change it
  theme: 'user',

  // Store token in local storage to remember user?
  // Patient/Secure Apps should set this to false
  storeToken: true,

  // Allow Biometrics to login
  // This will allow users to login using biometrics (fingerprint, Touch ID or Face ID)
  allowBiometrics: false,

  // Require timeout
  // Patient/Secure Apps will require that timeout is enabled
  // On timeout, user will be bumped
  requireTimeout: false,

  // Timeout threshold
  // Determine the number of seconds when timeout will occur
  // 15 minutes = 900000
  timeoutThreshold: 900000,

  // Enable Multi-language support
  // Shows the Select Language feature on login page, user menu, and account page
  // Update translator service with support languages
  enableMultiLanguageSupport: true,


   // API Key Index
   keys: [
    {
      deviceId: 'BMC_TRUAMA',
      skey: 'ca5fc174-4a80-41aa-bf22-a90abefd1ff2'
    }
  ]
};
